import MapboxProvider from '@resources/js/maps/MapboxProvider'

const POPUP_DEFAULT_OPTS = {
	maxWidth: 0,
	closeButton: false,
	offset: {
		top: [0, 25],
		'top-left': [0, 20],
		'top-right': [0, 20],
		bottom: [0, -20],
		'bottom-left': [0, -20],
		'bottom-right': [0, -20],
		left: [30, 0],
		right: [-30, 0],
	},
}

const MARKER_CLASSES = {
	ACTIVE: 'active',
	LOCKED: 'locked',
	VIEWED: 'viewed',
}

export default class MapView {
	#providerOptions
	#provider
	#markers = []

	constructor(mapOptions = {}, initOptions = {}) {
		this.container = document.querySelector('#mapbox')

		this.#providerOptions = {
			center: [this.container.dataset.lng, this.container.dataset.lat],
			control: 'bottom-right',
			...mapOptions,
		}

		this.#provider = new MapboxProvider(this.#providerOptions)
		this.#provider.init(initOptions)
	}

	addMainMarker(markerTemplate = null) {
		const marker = this.#provider.createMarker({
			coords: [this.container.dataset.lng, this.container.dataset.lat],
			markerTemplate,
		})
		this.#provider.addMarkerToMap(marker)
	}

	addMarkers(data, templateGenerator) {
		// data має містити id, lng, lat
		data.forEach(item => {
			if (item.lng && item.lat) {
				const marker = this.createMarker(
					item,
					templateGenerator ? templateGenerator(item) : null
				)

				this.#provider.addMarkerToMap(marker)
				this.#markers.push(marker)
			}
		})
	}

	clearMarkers() {
		this.#markers.forEach(marker => marker.remove())
		this.#markers = []
	}

	createMarker(item, template) {
		return this.#provider.createMarker({
			id: item.id,
			coords: [item.lng, item.lat],
			markerTemplate: template,
		})
	}

	getMarkerById(id) {
		return this.#markers.find(marker => marker.markerID === id)
	}

	activateMarker(placeId) {
		this.resetActivePlaces()

		const marker = this.getMarkerById(placeId)
		if (!marker) return

		marker.getElement().classList.add(MARKER_CLASSES.ACTIVE)
	}

	lockMarker(id) {
		this.getMarkerById(id)?.getElement().classList.add(MARKER_CLASSES.LOCKED)
	}

	unlockMarker(id) {
		this.getMarkerById(id)?.getElement().classList.remove(MARKER_CLASSES.LOCKED)
	}

	setMarkerViewed(id) {
		this.getMarkerById(id)?.getElement().classList.add(MARKER_CLASSES.VIEWED)
	}

	resetActivePlaces() {
		this.#markers.forEach(marker => {
			const markerElement = marker.getElement()

			markerElement.classList.remove(MARKER_CLASSES.ACTIVE)
		})
	}

	setPopupToMarkerById(id, template, popupOpts = {}) {
		const marker = this.getMarkerById(id)
		if (!marker) return false

		const popup = this.createPopup(template, popupOpts)
		marker.setPopup(popup)

		return popup
	}

	createPopup(template, opts = {}) {
		const popupOptions = {
			...POPUP_DEFAULT_OPTS,
			...opts,
		}

		return this.#provider.createPopup(popupOptions, template)
	}

	closePopupById(id) {
		const marker = this.getMarkerById(id)

		if (!marker) return

		const popup = marker.getPopup()
		if (popup) popup.remove()
	}

	fitByCoords(coords) {
		if (!coords?.length) return

		const bounds = this.#provider.generateBounds(coords)
		this.#provider.fitBounds(bounds)
	}
}
